import { footerLinks, siteMeta } from '@/mocks/homeData';

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                六
              </span>
              <span className="font-heading text-xl font-bold">{siteMeta.name}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/75">
              {siteMeta.column}是站内固定栏目，也是快速上头的入口。每天围绕独立专题，把人物关系、相关对话、投稿截图和网友反应汇总在同一条，省去东拼西凑。
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#top" className="transition-colors hover:text-accent-300">
                栏目导航
              </a>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-2 md:grid-cols-1">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-background-100/75 transition-colors hover:text-accent-300">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-sm font-bold text-background-50">
              <a href="#submit" className="transition-colors hover:text-accent-300">
                栏目说明
              </a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-100/75">
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-accent-300">
                  <i className="ri-time-line" />
                </span>
                {siteMeta.updateText}，每天一条完整整理
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-accent-300">
                  <i className="ri-folder-open-line" />
                </span>
                往期归档共 {siteMeta.archiveCount} 条
              </li>
              <li className="flex items-center gap-2">
                <span className="flex h-4 w-4 items-center justify-center text-accent-300">
                  <i className="ri-upload-2-line" />
                </span>
                投稿入口每日开放审核
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑料六点 · {siteMeta.column} 每日栏目</p>
          <p>本页为静态展示，内容与入口均为示意</p>
        </div>
      </div>
    </footer>
  );
}